import { render, staticRenderFns } from "./LiveChatVideoWidget.vue?vue&type=template&id=20ce0286"
import script from "./LiveChatVideoWidget.vue?vue&type=script&lang=js"
export * from "./LiveChatVideoWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports